import { render } from "./PageDownView.vue?vue&type=template&id=4bc095e4&scoped=true"
const script = {}

import "./PageDownView.vue?vue&type=style&index=0&id=4bc095e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9243d0548d070ce3cb63e50486d60596/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc095e4"]])

export default __exports__